import { createAsyncReducer } from '@telstra-connect/standard-actions';

import {
    ILoadRefundAdjustmentDetail,
    ILoadRefundAdjustmentDetailSuccessAction,
    LoadRefundAdjustmentDetailErrorAction
} from '../actions/load-refund-adjustment-details';
import { IBillingState } from '../state';
import { initialState } from '../state/initial-state';

export type LoadRefundAdjustmentDetailAction
    = ILoadRefundAdjustmentDetail
    | ILoadRefundAdjustmentDetailSuccessAction
    | LoadRefundAdjustmentDetailErrorAction;

const init = (state: IBillingState, action: LoadRefundAdjustmentDetailAction) => ({
    ...state,
    refundAdjustmentDetail: {
        ...state.refundAdjustmentDetail,
        status: action.status
    }
});

const success = (state: IBillingState, action: LoadRefundAdjustmentDetailAction) => ({
    ...state,
    refundAdjustmentDetail: {
        status: action.status,
        data: (action as ILoadRefundAdjustmentDetailSuccessAction).data
    }
});

const failure = (state: IBillingState, action: LoadRefundAdjustmentDetailAction) => ({
    ...state,
    refundAdjustmentDetail: {
        ...initialState.refundAdjustmentDetail,
        status: action.status,
        error: (action as LoadRefundAdjustmentDetailErrorAction).error,
        errorCode: (action as LoadRefundAdjustmentDetailErrorAction).errorCode
    }
});

export const loadRefundAdjustmentDetailReducer = createAsyncReducer(initialState, init, success, failure);
